// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import PipDetails, {getDefaultState as getPipDetailsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const PipDetailsState = t.struct({
    busyCounter: BusyCounter,
    pipDetails: PipDetails,
    searchFilters: SearchFilters
}, 'PipDetailsState');

export const getDefaultState = () =>
    new PipDetailsState({
        busyCounter: getBusyCounterDefaultState(),
        pipDetails: getPipDetailsDefaultState(),
        searchFilters: getSearchFiltersDefaultState()
    });

export default PipDetailsState;



// WEBPACK FOOTER //
// ./src/pip/pip-details/state/index.js